/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Mobile_Chapter_Continue_InInputs */

const en_mobile_chapter_continue_in = /** @type {(inputs: Mobile_Chapter_Continue_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Continue in ${i?.time}`)
};

const es_mobile_chapter_continue_in = /** @type {(inputs: Mobile_Chapter_Continue_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Continuar en ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Continue in {time}" |
*
* @param {Mobile_Chapter_Continue_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_chapter_continue_in = /** @type {((inputs: Mobile_Chapter_Continue_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Chapter_Continue_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_chapter_continue_in(inputs)
	return en_mobile_chapter_continue_in(inputs)
});